/* Explainability copy for the dashboard's two headline dollar figures (OPSS-238).
 *
 * Contract anchor — keep in step with the API, this copy makes a public claim
 * about how the numbers are derived:
 *   savings → ai21-intelligent-gateway-api `analytics/service.py`
 *             `_byte_derived_savings_usd`: (bytes_before − bytes_after) / 4
 *             tokens, priced per model at that model's own cache-read rate. No
 *             input-rate fallback (OPSS-256: `cache_read == 0` also means "prefix
 *             written this turn, not read back yet", and the fallback over-stated
 *             those ~10x), and the byte basis counts only requests that reached a
 *             provider.
 *   spend   → `Summary.cost.total`: input + output + cache-read + cache-write
 *             tokens at each model's per-token rate from `ig_analytics.model_pricing`
 *             (the OpenRouter ledger); unpriced models contribute 0.
 * The card percentage is savings / (spend + savings) — a share of gross, see
 * `analytics/savings.ts` savedPct. */

export const SAVINGS_HINT =
  "What the gateway kept off your bill. We measure the bytes removed from each request before it reaches the model, convert them to tokens, and price them at each model's cache-read rate — what that content costs once cached. Requests that never reached a model aren't counted. The percentage is savings ÷ (spend + savings).";

export const SPEND_HINT =
  "What your gateway traffic cost in this window: input, output, cache-read and cache-write tokens, each priced at its model's published rate. Models without a published rate aren't counted, and failed requests consume no tokens — so they're in the request count but not in this figure.";

export const SAVED_OVER_TIME_HINT =
  "Each bar is what the window would have cost without the gateway — the grey stem is what you paid, the dark cap is what you saved. The dashed line is the window average. Each bucket's savings follow its share of spend.";
